export enum Filetype {
  txt = "text/plain",
  pdf = "application/pdf",
  csv = "text/csv",
  doc = "application/msword",
  docx = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ppt = "application/vnd.ms-powerpoint",
  pptx = "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  xls = "application/vnd.ms-excel",
  xlsx = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  json = "application/json",
  png = "image/png",
  jpg = "image/jpeg",
  svg = "image/svg+xml",
}

